import { render, staticRenderFns } from "./AddFutures.vue?vue&type=template&id=6577b5ae&scoped=true"
import script from "./AddFutures.vue?vue&type=script&lang=js"
export * from "./AddFutures.vue?vue&type=script&lang=js"
import style0 from "./AddFutures.vue?vue&type=style&index=0&id=6577b5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6577b5ae",
  null
  
)

export default component.exports